import React from 'react';

const ClienteHeader = (props) => {
    const { cliente, datosCliente } = props;

    let cuit = "";

    if (cliente && cliente.NumeroDocumento) {
        cliente.NumeroDocumento = cliente.NumeroDocumento.toString();
        cuit = cliente.NumeroDocumento.includes("-") ? cliente.NumeroDocumento : cuit + cliente.NumeroDocumento.substring(0, 2) + "-" + cliente.NumeroDocumento.substring(2, ((cliente.NumeroDocumento.length) - 1)) + "-" + cliente.NumeroDocumento[cliente.NumeroDocumento.length - 1]
    }

    let iconoPersona = cliente.DatosClientes.TipoPersona == "J" ? <div className="iconoPersonaJuridicaDiv"><div className="iconoPersonaJuridicaImg" ></div></div> : <span className="icon-ti-user-icon-persona-cyan"></span>

    return (
        <div className="bottom-separator-xs">
            <div className="row">
                <div className="col-md-12">
                    <h1>
                        {cliente.identidadCliente}
                    </h1>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <ul className="no-bullets no-padding no-margin">
                        <li className="inlineListItem lg-margin clienteSubtitle">
                            {iconoPersona}&nbsp; {cliente.TIPO_DOCUMENTO} &nbsp; {cliente.DatosClientes.TipoPersona == "J" ? cuit : cliente.DatosClientes.NumeroDocumento}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}


export default ClienteHeader;